import { useEffect } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { fetchApiRef } from '@backstage/frontend-plugin-api';
import { getBrowserTelemetryConfig } from './browser-telemetry-config';

function createCorrelationId(): string {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }

  return `browser-telemetry-${Date.now().toString(36)}`;
}

function getErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}

function getErrorStack(error: unknown): string | undefined {
  return error instanceof Error ? error.stack : undefined;
}

export function BrowserTelemetryInitializer() {
  const fetchApi = useApi(fetchApiRef);

  useEffect(() => {
    const browserTelemetryConfig = getBrowserTelemetryConfig();
    if (!browserTelemetryConfig.enabled) {
      return undefined;
    }

    let cancelled = false;

    import('./browser-telemetry')
      .then(({ initializeBrowserTelemetry }) => {
        if (!cancelled) {
          initializeBrowserTelemetry(browserTelemetryConfig, {
            fetch: fetchApi.fetch.bind(fetchApi),
          });
        }
      })
      .catch((error: unknown) => {
        console.error(
          JSON.stringify({
            timestamp: new Date().toISOString(),
            level: 'error',
            message: 'Failed to initialize browser telemetry',
            correlationId: createCorrelationId(),
            errorMessage: getErrorMessage(error),
            errorStack: getErrorStack(error),
          }),
        );
      });

    return () => {
      cancelled = true;
    };
  }, [fetchApi]);

  return null;
}
